// extracted by mini-css-extract-plugin
export default {"tooltip":"UP-z","arrow":"VP-z"};